import axios from 'axios';
import { API_URL } from '../config/env';
import { loginPathWithReturn } from '../utils/authRedirect';

axios.defaults.baseURL = API_URL;

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url = String(error.config?.url || '');
    const skipRedirect =
      url.includes('/api/auth/login') ||
      url.includes('/api/auth/set-password') ||
      url.includes('/api/auth/accept-invite') ||
      url.includes('/api/auth/logout');
    if ((status === 401 || status === 403) && !skipRedirect) {
      localStorage.removeItem('token');
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = loginPathWithReturn(
          window.location.pathname + window.location.search
        );
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
